import React from 'react';
import { TextField, Step } from '../SteppedForm';

const StepTerminalid = (props) => {
  return (
    <Step
      id="terminalid"
      title={props.getPersonalDetailsTitle('Cabcharge Terminal ID')}
      skip={(formdata) =>
        !props.getApplicant().spotto ||
        !props.getApplicant().cabequip ||
        formdata.onboardingFor === 'vehicle'
      }>
      <TextField id="terminalid" label="What is your Cabcharge payments terminal ID?" required />
    </Step>
  );
};

export default StepTerminalid;
